import { useEffect } from "react";
import axios, { AxiosInstance, CancelToken } from "axios";
import AuthService from "./auth.service";

export default class AxiosFactory {
  axios: AxiosInstance;

  constructor(cancelToken?: CancelToken) {
    let headers = {};

    if (AuthService.loggedIn()) {
      const token = AuthService.getToken();
      headers = { Authorization: token };
    }

    this.axios = axios.create({
      // timeout: 15000,
      baseURL: `${process.env.REACT_APP_API_PATH}/`,
      headers: headers,
      cancelToken,
    });
  }
}

export const CancelSignal = axios.CancelToken.source;

/**
 * Method checks axios error for cancellation event.
 *
 * @returns {boolean}
 */
export const isCancelSignal = (e: any) => axios.isCancel(e);

export const useAxios = () => {
  const signal = CancelSignal();
  const axios = new AxiosFactory(signal.token).axios;

  useEffect(() => {
    return () => {
      signal.cancel("Unmount useAxios");
    };
    // eslint-disable-next-line
  }, []);

  return axios;
};

export const useCancelAxios = () => {
  const signal = CancelSignal();
  const axios = new AxiosFactory(signal.token).axios;

  useEffect(() => {
    return () => {
      signal.cancel("Unmount useAxios");
    };
    // eslint-disable-next-line
  }, []);

  return { axios, signal };
};
